<template>
  <Dialog
    title="批量修改学期"
    :visible.sync="dialogVisible"
    width="800px"
    :before-close="cancel"
  >
    <el-form ref="formRef" :model="form" label-width="120px" :rules="rules">
      <el-form-item label="学期" prop="term">
        <el-select
          v-model="form.term"
          placeholder="请选择"
          style="width: 100%;"
        >
          <el-option
            v-for="item in termList"
            :key="item.dictValue"
            :label="item.dictLabel"
            :value="item.dictValue"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button plain round size="small" @click="cancel">取 消</el-button>
      <el-button plain round size="small"
        type="primary"
        :loading="submitLoading"
        @click="submitForm"
        >确 定</el-button
      >
    </div>
  </Dialog>
</template>
<script>
import { getIntDictOptions } from "@/utils/dict";
import { batchUpdateTerm } from "@/api/student";

export default {
  data() {
    return {
      form: { term: null, memberWechatIds: [] },
      dialogVisible: false,

      type: "",
      submitLoading: false
    };
  },
  computed: {
    termList() {
      return getIntDictOptions("term");
    },

    rules() {
      return {
        term: [{ required: true, message: "请选择学期", trigger: "blur" }]
      };
    }
  },
  methods: {
    async open(ids) {
      this.dialogVisible = true;
      this.form = { term: null, memberWechatIds: ids };
    },
    async submitForm() {
      if (this.submitLoading) return;
      await this.$refs.formRef.validate();
      const payload = { ...this.form };

      this.submitLoading = true;
      try {
        await batchUpdateTerm(this.form);
        this.cancel();
        this.$emit("success");
      } catch (e) {
      } finally {
        this.submitLoading = false;
      }
    },
    cancel() {
      this.$refs.formRef.resetFields();
      this.form = { term: null, memberWechatIds: [] };
      this.dialogVisible = false;
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/students/TermUpdate.vue